import * as React from "react";
const SvgMicOn20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 0a5 5 0 0 0-5 5v4a5 5 0 0 0 10 0V5a5 5 0 0 0-5-5ZM7 5a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0V5ZM2 8v1a8.001 8.001 0 0 0 7 7.938V18H6v2h8v-2h-3v-1.062A8.001 8.001 0 0 0 18 9V8h-2v1A6 6 0 0 1 4 9V8H2Z",
      clipRule: "evenodd"
    })
  );
export default SvgMicOn20Px;
